import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getSellsByHour } from "../../../../store/dashboard/actions";
import { Bar } from "react-chartjs-2";
import * as charts from "./_charts";
import { selectorChart, formatHelper } from "../../../../common/helpers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Row,
  Col,
  Alert,
  Label,
} from "reactstrap";
import moment from "moment";
import { ExportCSV } from "../../../../components";
import { getSellsByHour as salesByDayExport } from "../../../../service/dashboard";
import { roles, messages, layout } from "../../../../common/constants";
import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import Select from "react-select";
import { exportExcel } from "./excel";

const sellState = [
  { value: 0, label: "(TODOS)" },
  { value: 1, label: "Aprobados" },
  { value: 2, label: "Pendientes" },
];

class CardSellsByHour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSellsByHour: true,
      requestDate: null,
      loadingExport: false,
      selectedStore: null,
      selectSellState: null,
    };
    this.handleObtainSalesExport = this.handleObtainSalesExport.bind(this);

    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleSellStateChange = this.handleSellStateChange.bind(this);
  }

  async handleSellStateChange(value) {
    if (value == this.state.selectSellState) return;
    await this.setState({ selectSellState: value, page: 1 });

    if (this.state.requestDate != null) {
      this.props.getSellsByHour({
        requestDate: this.state.requestDate._d,
        store: this.state.selectedStore.value,
        state: this.state.selectSellState.value,
      });
    }
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });

    if (this.state.requestDate != null) {
      this.props.getSellsByHour({
        requestDate: this.state.requestDate._d,
        store: this.state.selectedStore.value,
        state: this.state.selectSellState.value,
      });
    }
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
      this.setState({ selectSellState: sellState[0] });
    }
  }

  handleDateChange(value) {
    this.setState({
      requestDate: value,
    });
    if (value != null) {
      this.props.getSellsByHour({
        requestDate: value._d,
        store: this.state.selectedStore.value,
        state: this.state.selectSellState.value,
      });
    }
  }

  async handleObtainSalesExport() {
    this.setState({ loadingExport: true });
    const { requestDate, selectedStore } = this.state;
    salesByDayExport(requestDate._d, selectedStore.value).then((response) => {
      exportExcel(response.data.data, selectedStore, requestDate);
      this.setState({ loadingExport: false });
    });
  }

  render() {
    const className = "form-control mt-2";
    const { requestDate } = this.state;
    return (
      <Card>
        <CardHeader
          onClick={() =>
            this.setState({ showSellsByHour: !this.state.showSellsByHour })
          }
        >
          Ventas Hora - Dia
        </CardHeader>
        <Collapse isOpen={this.state.showSellsByHour}>
          <CardBody>
            <Row className="mb-2">
              <Col md="4">
                <Row>
                  <Col sm="5">
                    <Label className="mt-2">Fecha a Seleccionar:</Label>
                  </Col>
                  <Col sm="7">
                    <DatePicker
                      selected={
                        requestDate != null
                          ? moment(requestDate, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(requestDate) =>
                        this.handleDateChange(requestDate)
                      }
                      className={className}
                      dateFormat={"DD/MM/YYYY"}
                      showYearDropdown
                      showMonthDropdown
                    />
                  </Col>
                </Row>
              </Col>
              <Col md="5">
                {(this.props.role == roles.SUPER_ADMIN ||
                  this.props.role == roles.ADMIN) && (
                  <Row className="mt-2">
                    <Col sm="5">
                      <Label className="mt-2">TIENDA:</Label>
                    </Col>
                    <Col sm="7">
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isLoading={this.props.loadingStores}
                        isSearchable={true}
                        noOptionsMessage={() => {
                          return messages.SELECT_NO_OPTIONS;
                        }}
                        placeholder=""
                        options={this.props.stores}
                        loadingMessage={() => {
                          return messages.SELECT_LOADING;
                        }}
                        onChange={this.handleStoreChange}
                        value={this.state.selectedStore}
                        isDisabled={this.props.loadingStores}
                      />
                    </Col>
                  </Row>
                )}
              </Col>
              <Col md="3">
                {this.state.requestDate ? (
                  <div>
                    <ExportCSV
                      disabled={this.state.loadingExport}
                      exportCSV={this.handleObtainSalesExport}
                      minWidth={layout.MD_MIN_WIDTH}
                    />
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col md="4">
                <Row>
                  <Col sm="5">
                    <Label className="mt-2">Estado:</Label>
                  </Col>
                  <Col sm="7">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isLoading={this.props.loadingStores}
                      isSearchable={true}
                      noOptionsMessage={() => {
                        return messages.SELECT_NO_OPTIONS;
                      }}
                      placeholder=""
                      options={sellState}
                      loadingMessage={() => {
                        return messages.SELECT_LOADING;
                      }}
                      onChange={this.handleSellStateChange}
                      value={this.state.selectSellState}
                      isDisabled={this.props.loadingStores}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr className="my-4" />
            {this.state.requestDate != null ? (
              <Row>
                <Col>
                  <Bar
                    data={charts.SellsByHourData(
                      this.props.sellsByHourChartData
                    )}
                    options={charts.SellsByHourOptions()}
                  />
                </Col>
              </Row>
            ) : (
              <Row>
                <Col>
                  <Alert color="info">
                    Seleccione una fecha para visualizar los datos
                  </Alert>
                </Col>
              </Row>
            )}
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

function mapStateToProps(state) {
  const { sellsByHour, total, error, loading } =
    state.dashboard.sellsByHourList;
  return {
    error,
    loading,
    sellsByHourChartData: selectorChart.selectChartData(
      sellsByHour,
      "hour",
      "total",
      formatHelper.toTwoDecimal,
      total
    ),
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getSellsByHour,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CardSellsByHour);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsByHour/CardSellsByHour.js